module.exports = __webpack_public_path__ + "static/ClickedTripCancelled-562f1555aa1c3015789fbb32637426be.png";